import TabContext from '@components/tab/TabContext';
import styled from '@emotion/styled';
import {
    HTMLAttributes,
    ReactNode, useMemo, useState,
} from 'react';

interface Props extends HTMLAttributes<HTMLDivElement>{
    variant?: 'transparent' | 'solid';
    children?: ReactNode;
}

function TabList({ variant = 'transparent', children, ...rest }:Props) {
    const [currentId, setCurrentId] = useState<string>('');
    const borderWidth = useMemo(() => {
        try {
            const { length } = (children as ReactNode[]);
            return 100 / length;
        } catch {
            return 0;
        }
    }, [children]);
    const translateX = useMemo(() => {
        if (currentId) {
            let el = document.querySelector(`#${currentId}`);
            let index = -1;
            while (el) {
                el = el.previousElementSibling;
                index += 1;
            }
            return index * 100;
        }
        return 0;
    }, [borderWidth, currentId]);
    return (<TabContext value={{ variant, setCurrentId }}>
        {variant === 'solid' ? (
            <SolidTabList {...rest}>
                {children}
            </SolidTabList>
        ) : (
            <TransparentTabContainer {...rest}>
                <TransparentTabList>
                    {children}
                </TransparentTabList>
                <TabBorder width={borderWidth}
                    translateX={translateX} />
            </TransparentTabContainer>
        )}
    </TabContext>);
}

const SolidTabList = styled.div`
  background-color: var(--color-gray2);
  padding: 16px 20px;
  display: flex;
  gap: 4px;
  width: 100%;
  overflow-y: auto;
  white-space: nowrap;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const TransparentTabList = styled.div`
    display: flex;
    border-bottom: 2px solid var(--color-gray3);
    width: 100%;
    z-index: 2;
`;

const TransparentTabContainer = styled.div`
  width: 100%;
`;

const TabBorder = styled
    .div<{width: string|number, translateX: number}>`
    height: 2px;
    background-color: var(--color-primary);
    margin-top: -2px;
    transition: 200ms;
    width: ${(props) => props.width}%;
    transform: translateX(${(props) => props.translateX}%);
`;

export default TabList;
